export default __webpack_public_path__ + "static/media/profile-no-image.f63566e1.svg";